var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgManageInquiriesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 77,
    viewBox: "0 0 76 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.4922 31.6537V22.7474C62.4922 21.5664 62.023 20.4337 61.1879 19.5986C60.3528 18.7634 59.2201 18.2943 58.0391 18.2943H26.8672V13.8412C26.8672 12.6601 26.398 11.5274 25.5629 10.6923C24.7278 9.8572 23.5951 9.38803 22.4141 9.38803H9.05469C7.87365 9.38803 6.74098 9.8572 5.90585 10.6923C5.07073 11.5274 4.60156 12.6601 4.60156 13.8412V62.2318C4.61832 63.4444 5.07115 64.6104 5.87718 65.5165C6.68322 66.4226 7.78857 67.0081 8.99096 67.166C10.1934 67.3238 11.4124 67.0435 12.425 66.3762C13.4376 65.7089 14.1761 64.6993 14.5053 63.5321L21.4848 34.8629C21.7544 33.9364 22.3176 33.1225 23.0896 32.5437C23.8617 31.9649 24.8009 31.6526 25.7658 31.6537H66.9453C67.6279 31.6534 68.3014 31.8101 68.9138 32.1116C69.5262 32.4131 70.0611 32.8514 70.4772 33.3926C70.8933 33.9337 71.1793 34.5633 71.3133 35.2326C71.4473 35.9019 71.4257 36.5931 71.25 37.2527L64.7188 63.9715C64.4661 64.9201 63.9071 65.7587 63.1286 66.3568C62.3501 66.9549 61.3958 67.279 60.4141 67.2787H9.63953",
    stroke: "#E5E7EB",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageInquiriesIcon);
export default __webpack_public_path__ + "static/media/manageInquiriesIcon.9105cbd58b445f52db6ee050195c2c47.svg";
export { ForwardRef as ReactComponent };